import type { IconNode } from '../types';

/**
 * @name basketball
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgLz4KICA8cGF0aCBkPSJNMi4xIDEzLjRBMTAuMSAxMC4xIDAgMCAwIDEzLjQgMi4xIiAvPgogIDxwYXRoIGQ9Im01IDQuOSAxNCAxNC4yIiAvPgogIDxwYXRoIGQ9Ik0yMS45IDEwLjZhMTAuMSAxMC4xIDAgMCAwLTExLjMgMTEuMyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/basketball
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const basketball: IconNode = [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'M2.1 13.4A10.1 10.1 0 0 0 13.4 2.1', key: 'msdvl2' }],
  ['path', { d: 'm5 4.9 14 14.2', key: 'g75yt9' }],
  ['path', { d: 'M21.9 10.6a10.1 10.1 0 0 0-11.3 11.3', key: '162zqy' }],
];

export default basketball;
